import { useSelector } from 'react-redux';
import { deviceTypes } from '../../../shared/enums/deviceTypes';
import { getKey, getTab } from '../../../shared/utils/tabsUtils';
import { usePermission } from '../../../shared/hooks/usePermission';
import MyLearningWidget from '../../../shared/components/pages/myLearningPage/myLearningWidget/MyLearningWidget';
import DiscoveryWidget from '../../../shared/components/pages/discoveryPage/discoveryWidget/DiscoveryWidget';
import PlusLearningWidget from '../plusLearningPage/plusLearningWidget/PlusLearningWidget';
import MessagesWidget from './messagesWidget/MessagesWidget';
import UsefulToolsWidget from '../../../shared/components/pages/usefulToolsPage/usefulToolsWidget/UsefulToolsWidget';
import CalendarWidget from '../../../shared/components/pages/calenderPage/calendarWidget/CalendarWidget';
import BgtWidget from '../bgtPage/bgtWidget/BgtWidget';
import RealisticIsraelWidget from '../../../shared/components/pages/realisticIsrael/realisticIsraelWidget/RealisticIsraelWidget';
import ChampionshipWidget from './championshipWidget/ChampionshipWidget';
import GoogleMeetWidgetStudent from './googleMeetWidgetStudent/GoogleMeetWidgetStudent';
import SchoolLogoWidget from '../../../shared/components/widget/schoolLogoWidget/SchoolLogoWidget';
import SchoolImageWidget from '../../../shared/components/widget/schoolImageWidget/SchoolImageWidget';
import DefaultLogoWidget from '../../../shared/components/widget/defaultLogoWidget/DefaultLogoWidget';
import Footer from '../../../shared/layout/footer/Footer';
import WidgetPair from '../../../shared/components/features/widget/widgetPair/WidgetPair';
import SchedualMiniWidget from '../../features/SchedualMiniWidget/SchedualMiniWidget';
import classes from './Home.module.css';

const Home = () => {

    const { deviceType } = useSelector(state => state.responsive);
    const schoolData = useSelector(state => state.auth?.userDetails?.defaultSchool);
    const hasPermission = usePermission();
    const canSeeBgt = hasPermission(getKey("bgt"));

    return (
        <div className={classes.Home}>
            <div className={classes.Content}>
                <div className={classes.TopPart}>
                    <MessagesWidget />
                    <MyLearningWidget width={deviceType >= deviceTypes.columns3 ? 525 : 250} />
                    <div className={classes.WidgetsColumn}>
                        {canSeeBgt ?
                            <BgtWidget />
                            :
                            hasPermission(getTab("realisticIsrael")?.visibleTo) ?
                            <RealisticIsraelWidget />
                            :
                            <DefaultLogoWidget />
                        }
                        <UsefulToolsWidget />
                    </div>
                    <WidgetPair className={classes.CalendarWidgetPair}>
                        <CalendarWidget />
                        <SchedualMiniWidget className={classes.CalendarMiniWidget} />
                    </WidgetPair>
                </div>
                <div className={classes.BottomPart}>
                    {!hasPermission(getKey("googleMeet")) && <GoogleMeetWidgetStudent />}
                    {schoolData?.imageUrl && <SchoolImageWidget />}
                    <DiscoveryWidget />
                    <PlusLearningWidget />
                    {schoolData?.iconUrl && <SchoolLogoWidget />}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Home;
